import Swiper from 'swiper';
import 'swiper/css';

const CardsPortfiolio = () => {
    const components = document.querySelectorAll('[data-component="cards_portifolio"]');

    components.forEach(component => {
        const swiperComponent = component.querySelector('.swiper');

        const swiper = new Swiper(swiperComponent, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 12,
            breakpoints: {
                0: {
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                },
                1280: {
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 400,
                }
            }
        });
    });
};

export default CardsPortfiolio;

if (document.querySelectorAll('[data-component="cards_portifolio"]').length) {
    CardsPortfiolio();
}
